<template>
  <div class="tradein-detail">
    <div class="headline-s">Trade-in เก่าแลกใหม่</div>

    <div class="tradein-type">
      <div class="body-s text-gray-2 mb-3">ประเภท Trade-in</div>
      <div class="tradein-type-value">
        {{ optionMeta.label }}
        <span
          v-if="optionMeta.badgeLabel"
          class="badge"
          :style="badgeStyle"
        >
          {{ optionMeta.badgeLabel }}
        </span>
      </div>
      <div v-if="optionMeta.desc" class="tradein-type-desc">
        <v-icon size="16">mdi-information</v-icon>
        <span v-html="optionMeta.desc"></span>
      </div>
    </div>

    <div v-if="vouchers.length > 0" class="tradein-vouchers">
      <div
        v-for="(voucher, index) in vouchers"
        :key="index"
        class="tradein-voucher-item"
      >
        <div class="voucher-code">
          <v-icon size="16" color="#0071BC">
            mdi-ticket-confirmation-outline
          </v-icon>
          <span>{{ voucher.code }}</span>
        </div>

        <div class="voucher-amount">
          <div class="amount-label">
            <v-icon size="14" color="rgba(0,0,0,0.45)">
              mdi-swap-horizontal-circle-outline
            </v-icon>
            <span>ราคา Trade-in</span>
          </div>
          <div
            class="amount-value"
            :class="{
              '-is-tradein': type === TRADEIN_TYPE.TRADEIN,
              '-is-bntl': type === TRADEIN_TYPE.BNTL,
            }"
          >
            <template v-if="type === TRADEIN_TYPE.TRADEIN">
              ลดเลย!
            </template>
            {{ voucher.amount | currency }} บาท
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  TRADEIN_TYPE,
  PRE_TRADE_IN_OPTIONS,
  INTEREST_TRADE_IN_OPTIONS,
} from '@/config/order'

const TRADE_IN_OPTIONS = [
  ...PRE_TRADE_IN_OPTIONS,
  ...INTEREST_TRADE_IN_OPTIONS,
]

export default {
  name: 'OrderDetailTradeIn',

  props: {
    type: {
      type: String,
      default: null,
    },
    discount: {
      type: Number,
      default: 0,
    },
    vouchers: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      TRADEIN_TYPE,
    }
  },

  computed: {
    optionMeta() {
      return (
        TRADE_IN_OPTIONS.find(
          option => option.value === this.type,
        ) ?? {
          label: '',
          badgeLabel: null,
          badgeColor: null,
        }
      )
    },

    badgeStyle() {
      if (!this.optionMeta.badgeColor) return null

      return {
        backgroundColor: `${this.optionMeta.badgeColor}33`,
        color: this.optionMeta.badgeColor,
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.is-bnn {
    .tradein-detail {
        border: none;
    }
}
.tradein-detail {
    display: flex;
    flex-direction: column;
    gap: 16px;

    padding: 16px;
    background-color: #ffffff;
    border: 1px solid #E0E0E0;
    border-radius: 12px;
}

.tradein-type {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.tradein-type-label {
    font-size: 12px;
    color: rgba(#000000, 0.45);
}

.tradein-type-value {
    display: flow-root;
	align-items: baseline;

	font-size: 14px;
	font-weight: 500;
	color: rgba(#000000, 0.85);

    .badge {
        display: inline-flex;
        align-items: center;
        padding: 2px 6px;
        border-radius: 24px;
        font-size: 10px;
        font-weight: bold;
        white-space: nowrap;
    }
}

.tradein-type-desc {
	width: 100%;
	background-color: rgba($color-red, 0.1)
    border-radius: 8px
    padding: 8px 12px
    margin-top: 16px

    font-size: 14px
	font-weight: bold
    color: $color-red

    display: flex
    align-items: center
    gap: 8px

    .v-icon {
        color: $color-red
    }
}

.tradein-vouchers {
    display: flex;
    flex-direction: column;
    gap: 8px;
	margin-top: 8px;
}

.tradein-voucher-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;

    padding: 12px;
    background-color: #F8F8FA;
    border-radius: 8px;
}

.voucher-code {
    display: flex;
    align-items: center;
    gap: 6px;

	font-size: 14px;
    font-weight: 500;
    color: rgba(#000000, 0.85);
}

.voucher-amount {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
    text-align: right;

    .amount-label {
        display: flex;
		flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 4px;

        font-size: 12px;
        color: rgba(#000000, 0.45);
    }

    .amount-value {
		font-size: 14px;
        font-weight: 700;
        color: rgba(#000000, 0.85);

        &.-is-tradein {
            color: #1A7F37;
        }

        &.-is-bntl {
            color: #0071BC;
        }
    }
}
</style>
